module.exports = __webpack_public_path__ + "static/media/nav_jj_zscq_bg.08f02a10.png";